export default __webpack_public_path__ + "static/CircularStd-Medium-48ba1f51cf6953eb5e89bed2a6c07f24.ttf";